// @ts-nocheck
// TODO: tighten types after migration

import React, { useState, useEffect } from "react";
import "./Blog.css";
import Header from "../Header";
import Footer from "../footer";
import { useParams, NavLink, useNavigate } from "react-router-dom";
import { robustFetch } from "../utils/apiUtils";
import SEO from "./SEO";
import { getPostMetrics } from "./utils";
import { API_ENDPOINTS } from "../config/api";
import { getBlogPostPath } from "../utils/blogRoutes";
import BlogHeaderAd from "./BlogHeaderAd";
import PaginationControls from "../components/ui/PaginationControls";
import { getCategoryConfig } from "./Blog";

const POSTS_PER_PAGE = 10;

// Dummy comment count fetcher (replace with real API if needed)
function useCommentCount(postId) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!postId) return;
        fetch(API_ENDPOINTS.BLOG.THOUGHTS_COUNT(postId))
            .then(res => res.json())
            .then(data => setCount(data && typeof data.count === "number" ? data.count : 0))
            .catch(() => setCount(0));
    }, [postId]);
    return count;
}

function formatDate(dateStr) {
    try {
        if (!dateStr) return "Recently";
        const date = new Date(dateStr);
        // Check if date is valid
        if (isNaN(date.getTime())) {
            return "Recently";
        }
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        
        // Only show relative time for posts within 24 hours
        if (diffInSeconds < 86400) {
            if (diffInSeconds < 60) return 'Just now';
            if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
            if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
        }
        
        // For posts older than 24 hours, show actual date
        return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
        });
    } catch (e) {
        return "Recently";
    }
}

function Design(props) {
    const { post, readingTime } = props;
    const categoryLabel = post.categories && post.categories.length > 0 ? post.categories[0].name : '';
    const categoryConfig = getCategoryConfig(categoryLabel);
    const commentCount = useCommentCount(post.id);
    
    const [authorImages, setAuthorImages] = useState([]);
    const [authorCount, setAuthorCount] = useState(0);

    useEffect(() => {
        if (post.author && Array.isArray(post.author)) {
            const images = post.author.slice(0, 4).map(author => ({
                src: (author.image && Array.isArray(author.image) && author.image.length > 0 ? author.image[0].url : (author.image && author.image.url ? author.image.url : "/images/home_images/Logo.png")) || "/images/home_images/Logo.png",
                name: author.name
            }));
            setAuthorImages(images);
            setAuthorCount(post.author.length);
        } else if (post.author) {
            setAuthorImages([{
                src: (post.author.image && Array.isArray(post.author.image) && post.author.image.length > 0 ? post.author.image[0].url : (post.author.image && post.author.image.url ? post.author.image.url : "/images/home_images/Logo.png")) || "/images/home_images/Logo.png",
                name: post.author.name
            }]);
            setAuthorCount(1);
        } else {
            // Fallback if no author data
            setAuthorImages([{
                src: "/images/home_images/Logo.png",
                name: "Hari Vishnu"
            }]);
            setAuthorCount(1);
        }
    }, [post.author]);

    const coverImageUrl = (post.coverImage && post.coverImage.url) || "/images/home_images/Logo.png";

    return (
        <NavLink 
            to={getBlogPostPath(post)} 
            className="post_outline"
            style={{ borderColor: categoryConfig.color }}
        >
            <div className="blog-thumbnail-container">
                <img src={coverImageUrl} alt={post.title} />
            </div>
            
            <div className="blog-info-row">
                <span className="blog-info-date">{formatDate(post.createdAt)}</span>
                <div className="blog-info-authors">
                    {authorImages.slice(0, 3).map((author, index) => (
                        <img 
                            key={index}
                            className="blog-author-img" 
                            src={author.src} 
                            alt={`${author.name} profile`}
                            title={author.name}
                            onError={(e) => {
                                e.target.src = "/images/home_images/Logo.png";
                            }}
                        />
                    ))}
                    {authorCount > 3 && (
                        <div className="blog-author-count">
                            +{authorCount - 3}
                        </div>
                    )}
                </div>
                {commentCount > 0 && (
                    <span className="blog-info-comments">
                        <i className="fi fi-rr-comment-alt"></i>
                        {commentCount}
                    </span>
                )}
                {readingTime > 0 && (
                    <span className="blog-info-reading-time">
                        <i className="fi fi-rr-clock"></i>
                        {readingTime} min
                    </span>
                )}
            </div>

            <div className="post_details">
                <div className="Heading">
                    <h2 className="title">{post.title}</h2>
                    <p className="content">{post.excerpt}</p>
                </div>
            </div>
        </NavLink>
    );
}

export default function CategoryPosts() {
    const { categoryName } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [result, setResult] = useState([]); // Renamed from allFilteredPosts
    const [displayCategoryName, setDisplayCategoryName] = useState(categoryName); // Category name to display
    
    // ========== MONGODB POSTS FETCHING START ==========
    const [mongoPosts, setMongoPosts] = useState([]);
    const [mongoLoading, setMongoLoading] = useState(true);
    const [mongoError, setMongoError] = useState(null);

    // Fetch posts from MongoDB BlogDb
    useEffect(() => {
        const fetchMongoPosts = async () => {
            try {
                setMongoLoading(true);
                setMongoError(null);
                
                const response = await robustFetch(API_ENDPOINTS.BLOG.POSTS);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                
                const postsData = await response.json();
                
                if (postsData && Array.isArray(postsData)) {
                    const publishedPosts = postsData.filter(post => post.isPublished === true);
                    
                    if (publishedPosts.length > 0) {
                        const formattedPosts = publishedPosts.map(post => ({
                            node: {
                                id: post._id || post.id,
                                postNumber: post.postNumber || 0,
                                createdAt: post.createdAt,
                                slug: post.slug,
                                title: post.title,
                                excerpt: post.description || post.excerpt || '',
                                coverImage: post.coverImage || { url: '' },
                                categories: post.category ? (Array.isArray(post.category) ? post.category : [post.category]) : [],
                                // Ensure postTopic includes topicSlug from MongoDB
                                postTopic: post.postTopic ? {
                                    ...(typeof post.postTopic === 'object' ? post.postTopic : {}),
                                    topicSlug: post.postTopic.topicSlug || (post.postTopic.topic ? post.postTopic.topic.toLowerCase().replace(/\s+/g, '-') : ''),
                                    topic: post.postTopic.topic || post.postTopic
                                } : null,
                                content: post.content || { html: '', json: null },
                                author: post.author || null,
                                photoCollection: post.photoCollection || [],
                                isPublished: post.isPublished
                            }
                        }));
                        
                        setMongoPosts(formattedPosts);
                    } else {
                        setMongoPosts([]);
                    }
                } else {
                    setMongoPosts([]);
                }
                setMongoLoading(false);
            } catch (err) {
                console.error('Error fetching MongoDB posts:', err);
                setMongoError(err);
                setMongoPosts([]);
                setMongoLoading(false);
                return;
            }
        };

        fetchMongoPosts();
    }, []);
    // ========== MONGODB POSTS FETCHING END ==========
    
    // Reset state when category changes
    useEffect(() => {
        setResult([]);
        setCurrentPage(1);
    }, [categoryName]);

    // Filter posts by category
    useEffect(() => {
        let allPosts = [];
        
        // Add MongoDB posts filtered by category slug
        if (mongoPosts.length > 0) {
            const mongoFiltered = mongoPosts.filter(post => {
                if (!post.node || !post.node.categories) return false;
                const categories = Array.isArray(post.node.categories) ? post.node.categories : [post.node.categories];
                return categories.some(cat => {
                    // Handle MongoDB format: cat is an object with _id, name, slug
                    let catSlug = '';
                    if (cat && typeof cat === 'object') {
                        catSlug = cat.slug || (cat.name ? cat.name.toLowerCase() : '');
                    } else if (cat && typeof cat === 'string') {
                        catSlug = cat.toLowerCase();
                    }
                    // Compare slugs (case-insensitive)
                    return catSlug && (catSlug === categoryName || catSlug === categoryName.toLowerCase() || categoryName.toLowerCase() === catSlug);
                });
            });
            allPosts.push(...mongoFiltered);
            console.log('📦 MongoDB filtered posts for category:', categoryName, mongoFiltered.length);
        }
        
        // Sort by postNumber (descending order)
        allPosts.sort((a, b) => {
            const postNumA = a.node && a.node.postNumber ? a.node.postNumber : 0;
            const postNumB = b.node && b.node.postNumber ? b.node.postNumber : 0;
            return postNumB - postNumA;
        });
        
        console.log('✅ Total filtered posts for category:', categoryName, allPosts.length);
        setResult(allPosts);
        
        // Extract category name from posts for display
        if (allPosts.length > 0) {
            const firstPost = allPosts[0];
            if (firstPost && firstPost.node && firstPost.node.categories) {
                const categories = Array.isArray(firstPost.node.categories) 
                    ? firstPost.node.categories 
                    : [firstPost.node.categories];
                
                // Find the category that matches the slug
                const matchingCategory = categories.find(cat => {
                    if (!cat) return false;
                    let catSlug = '';
                    if (typeof cat === 'object') {
                        catSlug = cat.slug || (cat.name ? cat.name.toLowerCase().replace(/\s+/g, '-') : '');
                    } else if (typeof cat === 'string') {
                        catSlug = cat.toLowerCase();
                    }
                    return catSlug && (catSlug === categoryName || catSlug === categoryName.toLowerCase() || categoryName.toLowerCase() === catSlug);
                });
                
                if (matchingCategory) {
                    // Use the category name if available
                    if (typeof matchingCategory === 'object' && matchingCategory.name) {
                        setDisplayCategoryName(matchingCategory.name);
                    } else {
                        // Fallback: format the slug to a readable name
                        const formattedName = categoryName
                            .split('-')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');
                        setDisplayCategoryName(formattedName);
                    }
                } else {
                    // Fallback: format the slug to a readable name
                    const formattedName = categoryName
                        .split('-')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ');
                    setDisplayCategoryName(formattedName);
                }
            } else {
                // Fallback: format the slug to a readable name
                const formattedName = categoryName
                    .split('-')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
                setDisplayCategoryName(formattedName);
            }
        } else {
            // Fallback: format the slug to a readable name
            const formattedName = categoryName
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
            setDisplayCategoryName(formattedName);
        }
    }, [mongoPosts, categoryName]);

    // Calculate pagination for filtered posts
    const totalFilteredPosts = result.length;
    const totalPages = Math.ceil(totalFilteredPosts / POSTS_PER_PAGE);
    const startIndex = (currentPage - 1) * POSTS_PER_PAGE;
    const endIndex = startIndex + POSTS_PER_PAGE;
    const currentPosts = result.slice(startIndex, endIndex);

    // Show loader only if both are loading and no posts
    if (mongoLoading && result.length === 0) {
        return (
            <>
                <Header />
                <div className="loader">Loading...</div>
                <Footer />
            </>
        );
    }
    
    // Handle errors gracefully - show posts if available even if Hygraph fails
    // Handle errors gracefully
    if (mongoError && result.length === 0 && !mongoLoading) {
        console.error('MongoDB Error:', mongoError);
        return (
            <>
                <Header />
                <div style={{ padding: '20px', textAlign: 'center', minHeight: '60vh' }}>
                    <h2>Unable to Load Posts</h2>
                    <p>There was an error loading posts for this category. Please try refreshing the page.</p>
                    <p style={{ color: '#666', fontSize: '14px', marginTop: '10px' }}>
                        Error: {mongoError.message || 'Unknown error'}
                    </p>
                </div>
                <Footer />
            </>
        );
    }

    const all_data = currentPosts.map((track, idx) => {
        const post = track.node;
        const readingTime = getPostMetrics(post).readingTime;
        
        
        return (
            <Design
                key={`${post.id}-${idx}`}
                post={post}
                readingTime={readingTime}
            />
        );
    });

    const hasNextPage = currentPage < totalPages;
    const hasPrevPage = currentPage > 1;

    return (
        <>
            <SEO 
                title={`${displayCategoryName} Articles – Blog`}
                description={`Read the latest ${displayCategoryName} articles and insights by Hari Vishnu.`}
                url={`https://www.harivishnu.in/blog/${categoryName}`}
                keywords={`${displayCategoryName}, blog, articles, technology, business, AI, programming, personal growth, insights`}
            />
            
            <Header />
            <div className="blog-header">
                <div className="blog-header-top-row">
                    <div className="blog-header-text">
                        <h1>{displayCategoryName}</h1>
                    </div>
                    <div className="blog-header-ad-wrapper">
                        <BlogHeaderAd />
                    </div>
                </div>
            </div>
            <div className="all_post_area">
                {all_data}
            </div>
            <PaginationControls
                currentPage={currentPage}
                totalPages={totalPages}
                containerClassName="pagination"
                previousDisabled={!hasPrevPage}
                nextDisabled={!hasNextPage}
                onPrevious={() => {
                    if (hasPrevPage) {
                        setCurrentPage(currentPage - 1);
                    }
                }}
                onNext={() => {
                    if (hasNextPage) {
                        setCurrentPage(currentPage + 1);
                    }
                }}
            />
            <Footer />
        </>
    );
}

